export default __webpack_public_path__ + "static/media/hkd.183c381d.png";